import {gql} from "@irati/utils/gql"
import fullProduct from "@irati/products/services/fragments/fullProduct"

const fragment = gql`
  fragment fullDealProductConfig on ProductConfig {
    limits {
      inWindow {
        dateWindow {
          from
          to
        }
        eventWindow {
          daysAfter
          daysBefore
          type
        }
      }
      overTime {
        maxPrice {
          price {
            currency
            value
          }
          timePeriod
        }
        numberOfItems {
          number
          timePeriod
        }
      }
      perRedemption {
        maxPriceBeforeDiscounts
        minPriceBeforeDiscounts
        numberOfItems
        numberOfProducts
      }
      forOpenValue {
        minValue
        maxValue
      }
    }
    products {
      ...fullProduct
      salePrice {
        currency
        discount
        value
      }
    }
  }
  ${fullProduct}
`

export const toString = fragment.loc.source.body

export default fragment
